module.exports = __webpack_public_path__ + "img/import-excel-img.c43e10b9.svg";